/** @format */

import { Grid } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'src/components';
import Breadcrumb from 'src/components/Breadcrumb';
import Page from 'src/components/Page';
import { normalizeContentDetail } from 'src/slices/topics';
import ExtranetContentBody from './ExtranetContentBody';

export default function ContentPreview() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const detail = useMemo(() => {
    const raw = location.state && location.state.previewDetail;
    if (!raw || typeof raw !== 'object') return null;
    return normalizeContentDetail(raw);
  }, [location.state]);

  if (!detail) {
    return <Navigate to="/administration/content/create" replace />;
  }

  const title = detail.title || t('contentEditor.preview');

  return (
    <Page className="topics-content-detail" title={title}>
      <Breadcrumb
        data={[
          { title: t('menu.extranet'), link: { pathname: '/extranet', state: { resetExtranetTopicNav: true } } },
          { title: t('contentEditor.preview'), link: { pathname: '/administration/content/create' } },
          { title }
        ]}
      />
      <Grid className="container container--narrow">
        <ExtranetContentBody detail={detail} showSkeleton={false} isLoadingOverlay={false} />
        <div className="topics-content-detail__action-buttons">
          <Button
            secondary
            type="button"
            label={t('contentEditor.backToEditor')}
            onClick={() => navigate('/administration/content/create')}
          />
        </div>
      </Grid>
    </Page>
  );
}
